import { Injectable } from '@angular/core';
import { LeanNetworkService } from 'src/app/tools/services/lean-network-service';
import { UserService } from './user-service';
import { BaseRequest } from 'src/app/tools/models/dtos/base-request';
import { ToastrService } from 'ngx-toastr';



@Injectable({
  providedIn: 'root'
})


export class  BaseService {

  constructor(
    protected toastr            : ToastrService,
    protected networkService    : LeanNetworkService,
    public    userService       : UserService) { }

  fieldsGet(entityName: string): Promise<any> {
    let request: BaseRequest = new BaseRequest(this.userService.userInfo);

    request.strArg1 = entityName;

    return new Promise((resolve, reject) => {
        this.networkService.post('kernel/controls/fieldsGet', request).then(result => {
            return resolve(result);   
        }, error => {
            reject(error);
        });
    });
}


}